var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloudDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3188 4.9075C14.7804 2.10437 12.3817 0 9.5 0C7.21208 0 5.225 1.3325 4.23542 3.2825C1.8525 3.5425 0 5.61438 0 8.125C0 10.8144 2.12958 13 4.75 13H15.0417C17.2267 13 19 11.18 19 8.9375C19 6.7925 17.3771 5.05375 15.3188 4.9075ZM13.4583 7.3125L9.5 11.375L5.54167 7.3125H7.91667V4.0625H11.0833V7.3125H13.4583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloudDownload);
export default __webpack_public_path__ + "static/media/iconCloudDownload.bb711ef2f224cec377ec9602a069e9d2.svg";
export { ForwardRef as ReactComponent };